import React from 'react';
import { LandUseChange, LandUseChangeRow } from '../../../../../../services/types/Calculator';
import { calculateLandUseChangeTransport } from '../../Utils/moduleCalculates';
import LandUseChangeBase from './LandUseChangeBase';

interface Props {
  landUseChange: LandUseChange;
  onUpdateLandUseChange: (updatedLandUseChange: LandUseChange) => void;
}

const LandUseChangeSectionTransport: React.FC<Props> = ({
  landUseChange,
  onUpdateLandUseChange,
}) => {
  const calculateSubtotal = (rows: LandUseChangeRow[]) => {
    const totalCarbonSum = rows.reduce(
      (sum, row) => sum + row.area * (row.aboveGBCarbon + row.belowGBCarbon),
      0
    );
    return rows.length > 0 ? totalCarbonSum * (44 / 12) : null;
  };

  return (
    <LandUseChangeBase
      landUseChange={landUseChange}
      onUpdateLandUseChange={onUpdateLandUseChange}
      calculateFunction={calculateLandUseChangeTransport}
      calculateSubtotal={calculateSubtotal}
    />
  );
};

export default LandUseChangeSectionTransport;
